import React, { Component } from 'react';
import moment from 'moment';

import RadioGroup from '../../RadioGroup';
import Radio from '../../RadioGroup/Radio';
import OtherPeriodForm from './OtherPeriodForm';

import './styles.css';

export const periodFilters = {
  LAST_30_DAYS: 'Últimos 30 dias',
  LAST_60_DAYS: 'Últimos 60 dias',
  LAST_90_DAYS: 'Últimos 90 dias',
  OTHER_PERIOD: 'Outro período',
};

export const periodFilterToDays = {
  [periodFilters.LAST_30_DAYS]: 30,
  [periodFilters.LAST_60_DAYS]: 60,
  [periodFilters.LAST_90_DAYS]: 90,
};

// helper functions

export const getPeriodFilterType = (initialDate, finalDate) => {
  if (moment().subtract(30, 'day').isSame(initialDate, 'day') && moment().isSame(finalDate, 'day')) {
    return periodFilters.LAST_30_DAYS;
  }

  if (moment().subtract(60, 'day').isSame(initialDate, 'day') && moment().isSame(finalDate, 'day')) {
    return periodFilters.LAST_60_DAYS;
  }

  if (moment().subtract(90, 'day').isSame(initialDate, 'day') && moment().isSame(finalDate, 'day')) {
    return periodFilters.LAST_90_DAYS;
  }

  return periodFilters.OTHER_PERIOD;
};

class PeriodField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFilter: getPeriodFilterType(props.initialPeriod, props.finalPeriod),
    };
  }

  _onChangeFilterType = (type) => {
    const { onChangeValue } = this.props;

    this.setState({ selectedFilter: type }, () => {
      onChangeValue({
        finalPeriod: moment().format('YYYY-MM-DD'),
        initialPeriod: moment().subtract(periodFilterToDays[type], 'day').format('YYYY-MM-DD'),
      });
    });
  }

  render() {
    const {
      onChangeValue, initialPeriod, finalPeriod,
    } = this.props;
    const { selectedFilter } = this.state;

    return (
      <div className="PeriodField">
        <RadioGroup
          value={selectedFilter}
          onChangeValue={this._onChangeFilterType}
        >
          <Radio
            value={periodFilters.LAST_30_DAYS}
            label={periodFilters.LAST_30_DAYS}
          />
          <Radio
            value={periodFilters.LAST_60_DAYS}
            label={periodFilters.LAST_60_DAYS}
          />
          <Radio
            value={periodFilters.LAST_90_DAYS}
            label={periodFilters.LAST_90_DAYS}
          />
          <hr className="PeriodField__divider" />
          <Radio
            value={periodFilters.OTHER_PERIOD}
            label={periodFilters.OTHER_PERIOD}
          />
        </RadioGroup>
        {
          selectedFilter === periodFilters.OTHER_PERIOD &&
          <OtherPeriodForm
            initialPeriod={initialPeriod}
            finalPeriod={finalPeriod}
            onChange={(values) => {
              onChangeValue({
                initialPeriod: moment(values.initialPeriod, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                finalPeriod: moment(values.finalPeriod, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              });
            }}
          />
        }
      </div>
    );
  }
}

export default PeriodField;
